import React from "react";
import PharmacyCard from "components/pharmacyCard/PharmacyCard";
import Spacer from "components/Spacer/Spacer";
import VisitSummaryContent from "components/visitSummaryAccordion/VisitSummaryContent";
import VisitSummaryContentHeading from "components/visitSummaryAccordion/VisitSummaryContentHeading";
import VisitSummaryContentParagraph from "components/visitSummaryAccordion/VisitSummaryContentParagraph";
import { useDermatologyVisitFlow } from "hooks/useVisitFlow";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { dermaVisitFlowReducers } from "reducers/dermatology/dermaVisitFlowReducer";
import { dermatology_sub_steps } from "helpers/enum";

function MedicalHistorySummary({ readOnly, data }) {
  const { incompleteData } = useDermatologyVisitFlow();
  const history = useHistory();
  const dispatch = useDispatch();
  return (
    <VisitSummaryContent
      readOnly={readOnly}
      onEditClick={() => {
        dispatch(
          dermaVisitFlowReducers.currentScreen({
            value: dermatology_sub_steps.medical_history,
          })
        );
        history.push("/visit/dermatology/new-visit");
      }}
    >
      <VisitSummaryContentHeading text="Social History" />
      <Spacer height={20}/>
      <div>
        {data.social_or_medical_history?.map((el, index) => (
          <div key={index} className="mb-4">
            <h2 className="text-2xl font-medium text-black">
              {index + 1}. {el?.question}
            </h2>
            {el?.answer_type_boolean ? (
              el?.answer === "NO" ||
              el?.health_profile_section === "excercise" ||
              el?.health_profile_section === "alcohol" ? (
                <p className="text-2xl">{`${el?.answer[0]}${el?.answer
                  .slice(1)
                  .toLowerCase()}`}</p>
              ) : (
                <div>
                  <p className="text-2xl">{`${el?.answer[0]}${el?.answer
                    .slice(1)
                    .toLowerCase()}`}</p>
                  {el?.form_of_tobacco ? (
                    <div>
                      <p className="text-2xl">Forms of tobacco:</p>
                      {el?.form_of_tobacco?.map((form) => (
                        <p className="text-xl">{form}</p>
                      ))}
                    </div>
                  ) : el?.selected_options ? (
                    <div>
                      <p className="text-2xl">Medical conditions:</p>
                      <p className="text-xl">
                        {el?.selected_options
                          ?.reduce(
                            (result, cur) =>
                              (result = [...result, ...cur?.diseases]),
                            []
                          )
                          ?.map((disease, idx) => (
                            <p className="text-2xl">
                              {idx + 1}. {disease}
                            </p>
                          ))}
                      </p>
                    </div>
                  ) : null}
                </div>
              )
            ) : (
              <p className="text-2xl">{`${el?.answer[0]}${el?.answer
                .slice(1)
                .toLowerCase()}`}</p>
            )}
          </div>
        ))}
      </div>
      
      <Spacer height={20} />
      <VisitSummaryContentHeading text="Medical History" />
      <VisitSummaryContentParagraph
        text={
          data?.history
            ? data?.history?.join(", ")
            : incompleteData?.history?.join(", ")
        }
      />
      <Spacer height={20} />
      <VisitSummaryContentHeading text="Allergies" />
      <VisitSummaryContentParagraph
        text={
          data?.allergies
            ? typeof data?.allergies[0] === "string"
              ? data?.allergies?.join(", ")
              : data?.allergies?.map((item) => item?.name)?.join(", ")
            : typeof incompleteData?.allergies[0] === "string"
            ? incompleteData?.allergies?.join(", ")
            : incompleteData?.allergies?.map((item) => item?.name)?.join(", ")
        }
      />
      <Spacer height={20} />
      <VisitSummaryContentHeading text="Medications" />
      <VisitSummaryContentParagraph
        text={
          data?.medications
            ? typeof data?.medications[0] === "string"
              ? data?.medications?.join(", ")
              : data?.medications?.map((item) => item?.name)?.join(", ")
            : typeof incompleteData?.medications[0] === "string"
            ? incompleteData?.medications?.join(", ")
            : incompleteData?.medications?.map((item) => item?.name)?.join(", ")
        }
      />
      <Spacer height={20} />
      <VisitSummaryContentHeading text="Skin Care Products" />
      <VisitSummaryContentParagraph
        text={
          data?.skin_care_products
            ? data?.skin_care_products?.join(", ")
            : incompleteData?.skin_care_products?.join(", ")
        }
      />
      <Spacer height={20} />
      <VisitSummaryContentHeading text="Pharmacy" />
      <div className="pt-8">
        <PharmacyCard
          removeEdit
          pharmacyAddess={
            data?.pharmacy_details?.address ??
            incompleteData?.pharmacy_details?.address
          }
        />
      </div>
      {data?.additional_info?.length ||
      incompleteData?.additional_info?.length ? (
        <>
          <Spacer height={20} />
          <VisitSummaryContentHeading text="Additional Details" />
          <VisitSummaryContentParagraph
            text={
              data?.additional_info?.length
                ? data?.additional_info
                : incompleteData?.additional_info
            }
          />
        </>
      ) : null}
    </VisitSummaryContent>
  );
}

export default MedicalHistorySummary;
